'use client';
/**
 * Public-publishing consent — ONE checkbox that grants a broad license (public
 * gallery + our YouTube channel + text reuse) for a rebate. The long disclosure
 * lives in a collapsible box. Shown on the REVIEW step (the last thing before
 * creating). Consent is persisted on the story with its version + timestamp.
 */
import { useTranslations } from 'next-intl';
import { CheckboxField } from '@/shared/components/ui/checkbox-field';

export function PublicConsentField({
  checked,
  onChange,
}: {
  checked?: boolean;
  onChange: (checked: boolean) => void;
}) {
  const t = useTranslations('content.wizard');
  return (
    <div className="rounded-md border px-4 py-3 space-y-2" data-testid="output-public-consent">
      <CheckboxField
        id="public-consent"
        checked={!!checked}
        onCheckedChange={(c) => onChange(c)}
        data-testid="output-public-consent-checkbox"
        label={t('output.publicConsentLabel')}
      />
      <details className="pl-7">
        <summary className="text-xs text-muted-foreground cursor-pointer select-none">
          {t('output.publicConsentSummary')}
        </summary>
        <p className="mt-1 text-xs text-muted-foreground leading-relaxed">
          {t('output.publicConsentDetails')}
        </p>
      </details>
    </div>
  );
}
